import { SettingsSubscriptionContainer } from "../SettingsSubscriptionContainer";
import { useTranslation } from "next-i18next";
import { IUserSubscriptionModel } from "@nf/common";

type TCurrentSubscriptionContainer = {
  hasActiveSub: boolean;
  currentSubscriptions: IUserSubscriptionModel[];
  onCancel?: (subscription: IUserSubscriptionModel) => void;
  onCancelPause?: () => void;
};

export const CurrentSubscriptionContainer = ({
  currentSubscriptions,
  hasActiveSub,
  onCancel,
  onCancelPause,
}: TCurrentSubscriptionContainer) => {
  const { t } = useTranslation("translations");

  return (
    <>
      <h2>{t("web_subscription_current")}</h2>
      {currentSubscriptions.map((sub) => (
        <SettingsSubscriptionContainer
          key={sub.Id}
          subscription={sub}
          hasActiveSub={hasActiveSub}
          onCancel={onCancel}
          onCancelPause={onCancelPause}
        />
      ))}
    </>
  );
};
